const isBlank = value => value === '.';
const isAcrossClueStart = (cols, grid, position) => (
  !isBlank(grid[position]) && (
    isBlank(grid[position - 1]) || position % cols === 0
  )
);
// eslint-disable-next-line no-unused-vars
const isAcrossClueEnd = (cols, grid, position) => (
  !isBlank(grid[position]) && (
    isBlank(grid[position + 1]) || (position + 1) % cols === 0
  )
);
const isDownClueStart = (cols, grid, position) => (
  !isBlank(grid[position]) && (
    isBlank(grid[position - cols]) || position - cols < 0
  )
);
const isDownClueEnd = (cols, grid, position) => (
  !isBlank(grid[position]) && (
    isBlank(grid[position + cols]) || position + cols >= grid.length
  )
);
const nextUp = (cols, grid, position) => {
  let nextCell = position;
  do {
    nextCell = (grid.length + nextCell - cols) % grid.length;
  } while (isBlank(grid[nextCell]))
  return nextCell;
};
const nextLeft = (cols, grid, position) => {
  let nextCell = position;
  do {
    nextCell = ((cols + nextCell - 1) % cols) + (Math.floor(nextCell / cols) * cols)
  } while (isBlank(grid[nextCell]))
  return nextCell;
};
const nextRight = (cols, grid, position) => {
  let nextCell = position;
  do {
    nextCell = ((nextCell + 1) % cols) + (Math.floor(nextCell / cols) * cols)
  } while (isBlank(grid[nextCell]))
  return nextCell;
};
const nextDown = (cols, grid, position) => {
  let nextCell = position;
  do {
    nextCell = (nextCell + cols) % grid.length;
  } while (isBlank(grid[nextCell]))
  return nextCell;
};
const next = (cols, grid, position) => {
  let nextAcross = position;
  do {
    nextAcross = (nextAcross + 1) % grid.length;
  } while (isBlank(grid[nextAcross]));
  let nextDown;
  if (isDownClueEnd(cols, grid, position)) {
    nextDown = nextCluesStart(cols, grid, position)[1];
  } else {
    nextDown = position;
    do {
      nextDown = (nextDown + cols) % grid.length;
    } while (isBlank(grid[nextDown]));
  }
  return [nextAcross, nextDown];
};
const prior = (cols, grid, position) => {
  let priorAcross = position;
  do {
    priorAcross = (grid.length + priorAcross - 1) % grid.length;
  } while (isBlank(grid[priorAcross]));
  let priorDown;
  if (isDownClueStart(cols, grid, position)) {
    priorDown = priorCluesStart(cols, grid, position)[1];
    do {
      priorDown += cols;
    } while (!isDownClueEnd(cols, grid, priorDown));
  } else {
    priorDown = position;
    do {
      priorDown = (grid.length + priorDown - cols) % grid.length;
    } while (isBlank(grid[priorDown]));
  }
  return [priorAcross, priorDown];
};
const currentCluesStart = (cols, grid, position) => {
  let startAcross = position;
  while (
    !isBlank(grid[startAcross - 1]) &&
    startAcross % cols !== 0
  ) startAcross--;
  let startDown = position;
  while (
    !isBlank(grid[startDown - cols]) &&
    startDown - cols >= 0
  ) startDown-=cols;
  return [startAcross, startDown];
};
const priorCluesStart = (cols, grid, position) => {
  const [currentAcross, currentDown] = currentCluesStart(cols, grid, position);
  let priorAcross = currentAcross;
  do {
    priorAcross = (grid.length + priorAcross - 1) % grid.length;
  } while (!isAcrossClueStart(cols, grid, priorAcross));
  let priorDown = currentDown;
  do {
    priorDown = (grid.length + priorDown - 1) % grid.length;
  } while (!isDownClueStart(cols, grid, priorDown));
  return [priorAcross, priorDown];
}
const nextCluesStart = (cols, grid, position) => {
  const [currentAcross, currentDown] = currentCluesStart(cols, grid, position);
  let nextAcross = currentAcross;
  do {
    nextAcross = (nextAcross + 1) % grid.length;
  } while (!isAcrossClueStart(cols, grid, nextAcross));
  let nextDown = currentDown;
  do {
    nextDown = (nextDown + 1) % grid.length;
  } while (!isDownClueStart(cols, grid, nextDown));
  return [nextAcross, nextDown];
};
const getAdjacentCells = ({
  gameData: { size: { cols }, grid }, position
}) => ({
  up: nextUp(cols, grid, position),
  down: nextDown(cols, grid, position),
  left: nextLeft(cols, grid, position),
  right: nextRight(cols, grid, position),
  next: next(cols, grid, position),
  prior: prior(cols, grid, position),
});
const getAdjacentClues = ({
  gameData: { size: { cols }, grid, gridnums }, position
}) => ({
  prior: priorCluesStart(cols, grid, position),
  current: currentCluesStart(cols, grid, position),
  next: nextCluesStart(cols, grid, position),
});
const leftUntilBlank = (grid, cols, position) => {
  const group = {};
  const rowStart = Math.floor(position / cols) * cols;
  let current = position;
  group[current] = true;
  while (--current >= rowStart && !isBlank(grid[current])) group[current] = true;
  return group;
};
const rightUntilBlank = (grid, cols, position) => {
  const group = {};
  const rowEnd = Math.ceil((position + 1) / cols) * cols;
  let current = position;
  group[current] = true;
  while (++current < rowEnd && !isBlank(grid[current])) group[current] = true;
  return group;
};
const upUntilBlank = (grid, cols, position) => {
  const group = {};
  let current = position;
  while (current >= 0 && !isBlank(grid[current])) {
    group[current] = true;
    current-=cols;
  }
  return group;
};
const downUntilBlank = (grid, cols, position) => {
  const group = {};
  let current = position;
  while (current < cols * cols + 1 && !isBlank(grid[current])) {
    group[current] = true;
    current+=cols;
  }
  return group;
};

export const clueEntry = (clue, across) => {
  let newClue = clue.split('.');
  newClue[0]+=across ? 'A' : 'D';
  newClue = newClue.join('.');
  return [
    parseInt(clue.match(/\d+/)[0]),
    newClue
  ]
};
export const getAdjacencyMap = (gameData) => gameData.grid.map((cell, position) => ({
  cells: getAdjacentCells({ gameData, position }),
  clues: getAdjacentClues({ gameData, position })
}));
export const getSelected = ({ gameData, gameState }) => {
  if (gameState.cursor.position === undefined) return {};
  if (gameState.cursor.isAcross) {
    return {
      ...leftUntilBlank(gameData.grid, gameData.size.cols, gameState.cursor.position),
      ...rightUntilBlank(gameData.grid, gameData.size.cols, gameState.cursor.position),
    }
  } else {
    return {
      ...upUntilBlank(gameData.grid, gameData.size.cols, gameState.cursor.position),
      ...downUntilBlank(gameData.grid, gameData.size.cols, gameState.cursor.position),
    }
  }
};
export const getHighlighted = ({ gameData, gameState }) => {
  if (gameState.cursor.position === undefined) return {};
  if (gameState.cursor.isAcross) {
    return {
      ...upUntilBlank(gameData.grid, gameData.size.cols, gameState.cursor.position),
      ...downUntilBlank(gameData.grid, gameData.size.cols, gameState.cursor.position),
    }
  } else {
    return {
      ...leftUntilBlank(gameData.grid, gameData.size.cols, gameState.cursor.position),
      ...rightUntilBlank(gameData.grid, gameData.size.cols, gameState.cursor.position),
    }
  }
};
